(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["AppBundle"] = factory();
	else
		root["AppBundle"] = root["AppBundle"] || {}, root["AppBundle"]["main"] = factory();
})(this, () => {
return 